import { useEffect, useRef } from "react";
import type { ShowWithPackages } from "../types";

interface Props {
  show: ShowWithPackages;
  artistName: string;
}

// Generates a 1080x1920 PNG suitable for TikTok/IG. Day 24 will polish styling.
export function ShareCard({ show, artistName }: Props) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const W = canvas.width;
    const H = canvas.height;

    const grad = ctx.createLinearGradient(0, 0, 0, H);
    grad.addColorStop(0, "#4c1d95");
    grad.addColorStop(1, "#0f172a");
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, W, H);

    ctx.fillStyle = "white";
    ctx.font = "bold 80px Inter, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(artistName, W / 2, 400);

    ctx.font = "48px Inter, sans-serif";
    ctx.fillText(`Best deal: ${show.venue.city}`, W / 2, 600);

    ctx.font = "bold 160px Inter, sans-serif";
    ctx.fillText(
      `$${(show.packages.cheapest.total_cents / 100).toFixed(0)}`,
      W / 2,
      900,
    );

    ctx.font = "32px Inter, sans-serif";
    ctx.fillText("all-in: ticket + flight + hotel", W / 2, 980);

    ctx.font = "36px Inter, sans-serif";
    ctx.fillText("concertdeals.app", W / 2, H - 120);
  }, [show, artistName]);

  return (
    <canvas
      ref={canvasRef}
      width={1080}
      height={1920}
      className="max-w-full rounded-lg shadow"
    />
  );
}
